<template>
    <div class="container" :style="{ left: showMenu ? 0 : '100%' }">
        <ul class="nav">
            <li @click.stop="changeMenu(0)" :class="{ active: activeIndex == 0 }"><i class="iconfont iconwupinku"></i> <span>物品库</span></li>
            <li @click.stop="changeMenu(1)" :class="{ active: activeIndex == 1 }"><i class="iconfont iconxinxibianji"></i> <span>信息管理</span></li>
        </ul>
        <!-- 物品库 -->
        <div 
            class="menu_0" 
            v-show="activeIndex == 0"
            v-loading="isLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <ul class="menu_left">
                <li :class="{ active: activeIndex2 == 0 }" @click="() => { activeIndex2 = 0; firstCategory = false; }"> <i class="iconfont iconfenlei-wode"></i> <span>我的</span> </li>
                <li v-for="item in firstCategories" :class="{ active: firstCategory === item.cateId && activeIndex2 == 1 }" :key="item.cateId" @click="() => { changeFirstCategory(item); activeIndex2 = 1; }">
                    <i :class="['iconfont', item.iconName || 'iconwupinku']"></i> <span>{{item.cateName}}</span> 
                </li>
            </ul>
            <div @click="refresh" class="refresh"> <i class="iconfont icongengxin"></i> </div>
            <div class="mine" v-show="activeIndex2 == 1">
                <div class="search">
                    <el-input suffix-icon="el-icon-search" placeholder="输入关键词查找模型" v-model="searchContent" @change="modelList = []; pageNo = 1; loadModels()" />
                </div>
                <div class="category_2">
                    <el-select v-model="secondCategory" @change="changeSecondCategory" placeholder="请选择" size="mini">
                        <el-option v-for="item in secondCategories" :key="item.cateId" :label="item.cateName" :value="item.cateId"></el-option>
                    </el-select>
                </div>
                <ul class="category_3">
                    <li @click="changeThirdCategory('')" :class="{ active: thirdCategory == '' }">全部</li>
                    <li v-for="item in thirdCategories" :key="item.cateId" @click="changeThirdCategory(item.cateId)" :class="{ active: thirdCategory == item.cateId }">{{item.cateName}}</li>
                </ul>
                <ul class="list" v-infinite-scroll="loadModels" :infinite-scroll-disabled="isLoading || noData" infinite-scroll-immediate="false">
                    <li v-for="(item, index) in modelList" :class="{ active: item.modelId == selectedModelId }" :key="index" @mousedown="selectedModelId = item.modelId; selectModelHandler(item)">
                        <img :src="item.preview | parseUrl" :alt="item.modelName" :title="item.modelName" />
                    </li>
                    <li class="empty" v-if="modelList.length == 0">
                        <img src="@/assets/img/none.png" />
                        <p>未找到相关模型</p>
                    </li>
                </ul>
            </div>
            <div class="mine" v-show="activeIndex2 == 0">
                <div class="search">
                    <el-input suffix-icon="el-icon-search" placeholder="输入关键词查找模型" v-model="searchContent" @change="myModelList = []; pageNo = 1; loadMyModels()" />
                </div>
                <div class="btn" style="padding-bottom: 15px;">
                    <a :href="baseUrl" target="_blank">添加模型</a>
                </div>
                <ul class="list" v-infinite-scroll="loadMyModels" :infinite-scroll-disabled="isLoading || noData" infinite-scroll-immediate="false">
                    <li v-for="(item, index) in myModelList" :key="index" @mousedown="selectedModelId = item.modelId; selectModelHandler(item)" :class="{ active: item.modelId == selectedModelId }">
                        <a :href="payUrl" target="_blank" class="pay" @mousedown.stop="() => null" v-if="item.payed === false">
                            <i class="iconfont iconzhifu"></i> <span>去支付</span>
                        </a>
                        <img :src=" 'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' + item.preview" :alt="item.modelName" :title="item.modelName" v-if="item.preview" />
                        <img src="@/assets/img/default.png" :alt="item.modelName" :title="item.modelName" v-else />
                    </li>
                    <li class="empty" v-if="myModelList.length == 0">
                        <img src="@/assets/img/none.png" />
                        <p>未找到相关模型</p>
                    </li>
                </ul>
            </div>
        </div>
        
        <!-- 信息管理 -->
        <div v-show="activeIndex == 1" class="menu_1">
            <div class="info_row"><span>名称 </span> <el-input v-model="modelInfo.name" :maxlength="20"></el-input></div>
            <div class="info_row">
                <span>一级分类 </span>   
                <el-select v-model="modelInfo.cate1Id" @change="onCateChange" placeholder="请选择">
                    <el-option
                        v-for="item in cateList"
                        :key="item.cateId"
                        :label="item.cateName"
                        :value="item.cateId">
                    </el-option>
                </el-select>
            </div>
            <div class="info_row">
                <span>二级分类 </span>   
                <el-select v-model="modelInfo.cate2Id" placeholder="请选择">
                    <el-option
                        v-for="item in subCateList"
                        :key="item.cateId"
                        :label="item.cateName"
                        :value="item.cateId">
                    </el-option>
                </el-select>
            </div>
            <div class="info_row">
                <span>封面 </span>
                <div class="preview" @click="changePreview">
                    <img v-if="modelInfo.preview" :src="modelInfo.preview" />
                    <div v-else>
                        <i class="iconfont iconjiahaotianjia"></i>
                        <p>自行上传</p>
                        <p>推荐尺寸: 760 * 520</p>
                    </div>
                </div>
            </div>
            <div class="info_row">
                <span class="blobk"></span>
                <div class="screen" @click.stop="screenShot"> 
                    <i class="iconfont iconjietu"></i> <span>截图设置封面</span> 
                </div>
            </div>
            
            <button hidden id="chooseAvatar"></button>
        </div>

        <div class="toggle" @click="toggleScreen">
            <i class="iconfont iconshangyibu1" v-if="!showMenu"></i>
            <i class="iconfont iconxiayibu" v-else></i>
        </div>
    </div>
</template>

<script>
import { ResponseCode } from '@/utils/axios'
import Cookie from "js-cookie"
import uuid from 'uuidjs'
import BusEvent from '@/busEvent'
import Util from '@/utils/util'

var baseUrl = process.env.MODE == 'pro' ? 'https://www.laozicloud.com' : 'https://www.laozicloud.net'
var pointer = Util.createIndicator()
export default{

    props: {
        sceneData: {
            default: {}
        }
    },

    filters: {
        parseUrl: function( url ){
            if(url.startsWith('https')){
                return url
            }
            return 'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' + url
        }
    },

    data(){
        return {
            hideCursor: false,
            activeIndex: 0,
            activeIndex2: 0,
            searchContent: '',
            modelList: [],      //当前分类下系统模型列表
            myModelList: [],    //我的模型列表
            cateList: [],       //信息管理编辑分类列表
            subCateList: [],    //二级分类
            modelInfo: {
                name: '',
                cate1Id: '',
                cate2Id: '',
                preview: ''
            },
            pageNo: 1,
            pageSize: 30,
            firstCategories: [],    //一级分类
            firstCategory: false,      //当前一级分类
            secondCategories: [],   //二级分类
            secondCategory: '',    //当前二级分类
            thirdCategories: [],    //三级分类
            thirdCategory: '',      //当前三级分类
            isLoading: true,
            noData: false,
            selectedModelId: '',
            baseUrl: baseUrl + '/transaction',
            payUrl: baseUrl + '/workbench/serviceResult',
            showMenu: true
        }
    },

    watch: {
        sceneData( val ){
            var { name, cate1Id, cate2Id, preview } = val
            this.modelInfo = {
                name,
                cate1Id,
                cate2Id,
                preview
            }
            this.onCateChange( cate1Id )
        }
    },

    computed: {

        viewer(){
            return window.viewer
        },

        container(){
            return window.viewer.container
        },

        tool(){
            return this.$parent.$refs.tool
        }
    },

    mounted(){
        this.init()
        this.loginEvent = () => {
            setTimeout(() => {
                this.init()
            }, 2000)
        }
        this.$bus.$on( BusEvent.LoginSuccess, this.loginEvent )
    },

    beforeDestroy(){
        this.$bus.$off( BusEvent.LoginSuccess, this.loginEvent )
    },


    methods: {

        init(){
            this.axios.post('/api-application/fullSceneEditor/unauth/worksCateList').then(res => {
                this.cateList = res.datas || []
                if( this.modelInfo.cate1Id ) this.onCateChange( this.modelInfo.cate1Id )
            })

            this.axios.post('/api-application/fullSceneEditor/getModelLibraryCateList').then(res => {
                this.firstCategories = res.datas || []
                this.changeFirstCategory( res.datas[0] )
            })

            if( Cookie.get('loginId') ){
                this.pageNo = 1
                this.myModelList = []
                this.noData = false
                this.loadMyModels()
            }
        },

        /**
         * 切换主菜单
         */
        changeMenu( index ){
            this.activeIndex = index
        },

        /**
         * 单击选中模型
         */
        selectModelHandler( model ){
            if( model.modelId ){
                this.isLoading = true
                this.axios.post( '/api-transaction/laozi/v3/transaction/unauth/model/modelPreview', {
                    modelId: model.modelId,
                    userId: Cookie.get('loginId')
                }).then( res => {
                    if( res.resp_code == ResponseCode.SUCCESS ){
                        if( res.datas.paths ){
                            this.toSetModel({
                                paths: res.datas.paths,
                                name: model.modelName,
                                id: model.modelId
                            })
                        }
                    }else{
                        console.warn( res.resp_msg )
                    }
                }).finally(() => {
                    this.isLoading = false
                })
            }else{
                this.$message.warning('模型ID丢失')
            }
        },

        /**
         * 初始化模型放置
         */
        toSetModel( model ){
            //关闭测量
            if( this.viewer.mapMeasure  ){
                this.viewer.mapMeasure.enable = false
            }
            if( this.viewer.root.getObjectByName('pointer') ){
                this.viewer.root.remove( pointer )
                this.container.removeEventListener( 'mousemove', this.mousemoveHandler )
                this.container.removeEventListener( 'mousedown', this.dropHandler )
            }
            this.viewer.root.add( pointer )
            this.$message.success( '请在地图中选择放置模型位置' )
            this.selected = model
            this.dropHandler = this.dropModel.bind(this)
            this.container.addEventListener( 'mousedown', this.dropHandler )
            this.container.addEventListener( 'mousemove', this.mousemoveHandler )
        },

        mousemoveHandler( e ){                                                                                                                                  
            if( !pointer ) return
            const intersect = this.viewer.picker.intersectObject( e, [ this.viewer.scene.floorMesh ] )
            if( !intersect ) return
            pointer.position.copy( intersect.point )
            const distance = this.viewer.camera.position.distanceTo( intersect.point )
            const scale = Math.max( 1, distance / 1000 )
            pointer.scale.set( scale, scale, scale )
        },

        /**
         * 放置模型
         */
        dropModel( e ){
            this.container.style.cursor = 'default'  //显示光标
            this.viewer.root.remove( pointer )
            this.container.removeEventListener( 'mousemove', this.mousemoveHandler )
            this.container.removeEventListener( 'mousedown', this.dropHandler )
            if( e.button == 2 ) return  //右键取消放置
 
            let loading = this.$loading()
            this.viewer.resourceManager.loadModel(this.selected.paths, {
                position: pointer.position,     //模型位置
                modelName: this.selected.name,  //模型名称
                sourceId: this.selected.id,     //模型来源
                mid: uuid.genV4().toString(),   //唯一ID
                onLoad: m => {
                    loading.close()
                    this.tool.toggleSelector()
                    this.viewer.operator.selectedObject = [ m ]
                    this.viewer.fitCamera( m )
                    this.showMenuStat( e )
                    this.$bus.$emit( BusEvent.SceneChange )
                    this.$bus.$emit( BusEvent.SelectedChange )
                }
            })
        },

        /**
         * 显示菜单按钮
         */
        showMenuStat( e ){
            this.tool.menuStat.visiable = true
            this.tool.menuStat.x = e.clientX
            this.tool.menuStat.y = e.clientY
        },

        /**
         * 更换预览图
         */
        changePreview(){
            this.$util.uploadOBS( 'image' ).then(res => {
                if( res.url ) this.modelInfo.preview = res.url
            })
        },

        /**
         * 修改物品库一级分类
         */
        changeFirstCategory( item ){
            this.firstCategory = item.cateId
            this.secondCategory = ''
            this.secondCategories = item ? item.children || [] : []
            if( this.secondCategories.length > 0 ){
                this.secondCategory = item.children[0].cateId
            }
            this.changeSecondCategory()
        },

        /**
         * 修改物品库二级分类
         */
        changeSecondCategory(){
            var item = this.secondCategories.find( item => item.cateId == this.secondCategory )
            this.thirdCategories = item ? item.children || [] : []
            this.thirdCategory = ''
            if( this.thirdCategories.length > 0 ){
                this.thirdCategory = item.children[0].cateId
                // this.changeThirdCategory( item.children[0].cateId )
                this.changeThirdCategory('')
                return
            }
            this.changeThirdCategory()
        },

        changeThirdCategory( cateId ){
            if( cateId !== undefined ) this.thirdCategory = cateId
            this.pageNo = 1
            this.modelList = []
            this.noData = false
            this.loadModels()
        },

        /**
         * 加载当前分类下系统模型
         */
        loadModels() {
            this.isLoading = true
            this.axios.post('/api-application/fullSceneEditor/defaultModelList', {
                teCate1: this.firstCategory,
                teCate2: this.secondCategory,
                teCate3: this.thirdCategory,
                modelName: this.searchContent,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }).then(res => {
                this.isLoading = false
                if( res.resp_code == 60000 && res.datas && Array.isArray(res.datas.results) ){
                    if( res.datas.results.length > 0 ){
                        this.modelList = this.modelList.concat(res.datas.results)
                        this.modelList = this.modelList.filter(item => item.modelType === 0)
                        res.datas.results.length > 0 && this.pageNo ++
                    }else if( this.pageNo > 1 ){
                        this.noData = true
                        this.$notify.info({
                            title: '提示',
                            message: '没有数据了',
                            duration: 1500,
                            position: 'bottom-right'
                        })
                    }
                }
            })
        },

        /**
         * 加载我的模型
         */
        loadMyModels(){
            this.isLoading = true
            this.axios.post('/api-application/fullSceneEditor/myModelList', { 
                userId: Cookie.get('loginId'),
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                modelName: this.searchContent
            }).then(res => {
                this.isLoading = false
                if( res.resp_code == 60000 && res.datas && Array.isArray(res.datas.results) ){
                    if( res.datas.results.length > 0 ){
                        this.myModelList.push(...res.datas.results)
                        res.datas.results.length > 0 && this.pageNo ++
                    }else if( this.pageNo > 2 ){
                        this.noData = true
                        this.$notify.info({
                            title: '提示',
                            message: '没有数据了',
                            duration: 1500,
                            position: 'bottom-right'
                        })
                    }
                }
            })
        },

        /**
         *  刷新数据
         */
        refresh(){
            this.init()
            this.activeIndex2 = 0
        },

        /**
         * 切换一级分类
         */
        onCateChange( cateId ){
            let cate = this.cateList.find( item => item.cateId == cateId )
            if( cate && Array.isArray( cate.worksLabelObjectVOList ) && cate.worksLabelObjectVOList.length > 0 ){
                this.subCateList = cate.worksLabelObjectVOList
                this.modelInfo.cate2Id = cate.worksLabelObjectVOList[0].cateId
            }else{
                this.modelInfo.cate2Id = ''
                this.subCateList = []
            }
            
        },

        /**
         * 截屏并上传
         */
        screenShot(){
            let loading = this.$loading()
            try {
                this.viewer.renderManager.render( true )
                var imgStr = this.viewer.renderManager.getRenderer().domElement.toDataURL('image/jpeg')
                this.axios.post('/api-transaction/laozi/v3/transaction/uploadImg', { imgStr }).then( res => {
                    loading.close()
                    this.modelInfo.preview = res.datas.url
                }) 
            } catch (error) {
                loading.close()
            }
        },

        toggleScreen(){
            this.showMenu = !this.showMenu
            this.$emit('toggleScreen', this.showMenu)
        }
    }
    
}

</script>

<style lang="scss" scoped>
.container{ 
    height: 100%; position: relative;
    .toggle{ 
        width: 24px; height: 48px; background-image: url('~@/assets/img/toggle.png'); background-size: contain; position: absolute; top: calc(50% - 12px); left: -24px; text-align: center; line-height: 48px; cursor: pointer;
        .iconfont{ font-size: 20px; color: #5D6B7F;  }
        &:hover{ 
            .iconfont{ font-size: 20px; color: #FFF;  }
        }
    }
}
.nav{
    display: flex; width: 100%; height: 48px; align-items: center; justify-content: space-around;
    li{ 
        span{ color: #3B3B3B; margin-top: 5px; font-size: 14px; }
        .iconfont{ color: #5D6B7F; font-size: 20px; position: relative; left: -5px; top: 2px; }
        width: 50%; height: 100%; border-left: 1px solid rgba(0,0,0,0.1); display: flex; align-items: center; justify-content: center; cursor: pointer;position: relative;border-bottom: 1px solid  rgba(0,0,0,0.1);
    }
    .active{
        span{ color: #1458EA; }
        .iconfont{ color: #1458EA; } 
    }
    .active::after{
        content: ''; display: block; position: absolute; width: 32px; height: 3px; border-radius: 1px; background-color: #1458EA; left: 50%; transform: translateX(-16px); bottom: -1px;
    }
}
.menu_0{
    width: 100%; height: calc(100% - 65px); background-color: #F2F4F6; display: flex;
    .menu_left{
        width: 50px; height: calc(100% - 50px); padding-bottom: 50px; display: flex; flex-direction: column; background-color: #fff; align-items: center; position: relative; overflow-y: scroll; margin-top: 1px;
        li{
            width: 100%; padding: 10px 0; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; position: relative;
            span{ display: block; width: 70%; font-size: 14px; text-align: center; color: #5D6B7F; }
            .iconfont{ font-size: 20px; color: #5D6B7F;}
            &:hover{
                span, .iconfont{color: #1458EA;}
            }
            &::after{
                content: ''; display: block; position: absolute; width: 28px; bottom: -1px; left: 10px; height: 1px; background-color: rgba(0,0,0,0.35); opacity: 0.5;
            }
            &:nth-last-child(1)::after{
                opacity: 0;
            }
        }

        .active{
            background-color: #F2F4F6;  border-color: #1458EA;
            span, .iconfont{color: #1458EA;}
            &::after{
                content: ''; display: block; position: absolute; width: 30px; bottom: 0; left: 10px; height: 1px; background-color: #1458EA; opacity: 0.5;
            }
        }
        scrollbar-width: none; /* Firefox */
        
    }
    .refresh{
        width: 50px; text-align: center; padding: 10px 0; cursor: pointer;
        position: absolute; bottom: 0; background-color: #fff; width: 50px;
        .iconfont{ font-size: 20px; color: #5D6B7F;}
    }
    .menu_left::-webkit-scrollbar-track, .menu_left::-webkit-scrollbar{ width: 0 !important; display: none !important; } /* Chrome Safari */
    .mine{
        width: calc(100% - 50px);
        .search{
            width: 100%; background-color: #fff; height: 54px; display: flex; justify-content: center; align-items: center; border-bottom: 1px solid rgba(0,0,0,0.1);
            /deep/ .el-input{
                width: 90%; height: 34px;
                .el-input__inner{border: none; height: 30px; background-color: #F2F4F6;}
                .el-input__suffix{top: -5px; color: #000;}
            }
        }
        .btn{
            display: flex; justify-content: center; padding: 15px 0; width: 100%;
            a{ 
                display: block; width: 90%; margin: 0 auto; height: 34px; line-height: 34px; text-align: center; background-color: #1458EA; color: #FFF; text-decoration: none; border-radius: 17px;
            }
        }
        .list{
            width: 314px; height: calc( 100% - 158px ); margin: 0 auto; overflow-y: scroll; scrollbar-width: thin;
            li{ 
                width: 30%; height: 92px; float: left; margin: 5px 0; display: flex; justify-content: center; cursor: pointer; position: relative; background: #FFF; margin-right: 4px; border: 3px solid transparent; border-radius: 10px;
                img{ width: 100%; height: 92px; -webkit-user-drag: none; border-radius: 5px;}
                .pay{
                    display: block; width: 92px; height: 92px; background-color:#182C49; opacity: 0.8; position: absolute; top: 0; left: 5px; border-radius: 5px; display: flex; flex-direction: column; justify-content: center; align-items: center; color: #FFF;
                    span{margin-top: 10px;}
                    .iconfont{font-size: 20px;}
                }
            }
            .empty{ 
                background: transparent;  margin: 20px auto; display: flex; flex-direction: column; align-items: center; width: 92%;
                img{ width: 92px; opacity: 0.5; }
                p{text-align: center; margin-top: 10px; color: #5D6B7F;}
            }
            .active{ border: 3px solid #1458EA; }
        }
        .category_2{
            width: 100%; display: flex; justify-content: center;background-color: #fff; padding: 10px 0;
            /deep/ .el-select{ width: 90%; }
        }
        .category_3{
            width: 96%; margin: 0 auto; display: flex;
            li{
                padding: 10px; color: #5D6B7F; font-size: 12px; cursor: pointer; flex-wrap: wrap;
                &:hover{color: #1458EA;}
            }
            .active{color: #1458EA;}
        }
    }
}
.menu_1{
    background-color: #F2F4F6; height: calc(100% - 65px);padding-top: 10px;
    .info_row{
        display: flex; justify-content: center; align-items: center; padding: 10px 0;
        >span{ display: block; margin-right: 10px;  font-size: 12px; color: #999; }
        /deep/ .el-input{
            width: 70%;
            .el-input__inner{ background-color: #fff; border: none; }
        }
        /deep/.el-select{ 
            width: 75%; 
            .el-input{ width: 100%; }
        }
        .blobk{display: inline-block; width: 24px;}
    }
    .screen{ 
        display: flex; justify-content: center; align-items: center; padding: 10px 0; width: 75%; background-color: #fff; cursor: pointer; border-radius: 5px;
        span{margin-left: 15px; color: #1458EA;}
        .iconfont{color: #1458EA;}
    }
}
.preview{
    background-color: #fff; padding: 10px; width: calc(70% - 20px); height: 180px; padding: 10px; border-radius: 5px; cursor: pointer;
    >img{ width: 100%; height: 100%; }
    >div{ 
        width: 100%; height: 100%; border-radius: 5px; border: 1px dotted #ccc; display: flex; flex-direction: column; justify-content: center; align-items: center;
        p{ color: #999; font-size: 14px; line-height: 22px; } 
        .iconfont{ color: #999; font-size: 22px; margin-bottom: 20px; }
    }
}

</style>
<style lang="scss">
.el-select-dropdown__item.selected {
    color: #1458ea !important;
    font-weight: 500 !important;
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #1458ea !important;
}
</style>